// Stencil
import { Component, Host, h, Prop, Element, getAssetPath } from "@stencil/core";
// Other Libraries
import { MercuryBundles } from "@genexus/mercury";
// Custom Imports
import { Locale } from "../../common/locale";

const COPYRIGHTS_ILLUSTRATION = getAssetPath(
  `./gx-ide-assets/welcome-page/images/copyrights-illustration.png`
);
const ICON_NEXT = getAssetPath(
  `./gx-ide-assets/welcome-page/images/icon-next.svg`
);
const CSS_BUNDLES: MercuryBundles = [
  "resets/box-sizing",
  "utils/typography",
  "components/button"
];

@Component({
  tag: "gx-ide-sign-in",
  styleUrl: "sign-in.scss",
  shadow: true,
  assetsDirs: ["gx-ide-assets/sign-in"]
})
export class GxIdeUiSplash {
  /**
   * The component hard-coded strings translations.
   */
  // eslint-disable-next-line @stencil-community/own-props-must-be-private
  #componentLocale: any;

  @Element() el: HTMLGxIdeSignInElement;

  /**
   * Callback executed when the user click on the "term and conditions" link
   */
  @Prop() readonly termsCallback: () => Promise<void>;

  /**
   * Callback executed when the user click the Sign In button
   */
  @Prop() readonly signInCallback: () => Promise<void>;

  async componentWillLoad() {
    this.#componentLocale = await Locale.getComponentStrings(this.el);
  }

  render() {
    return (
      <Host>
        <ch-theme model={CSS_BUNDLES}></ch-theme>
        <section class="slide">
          <div
            class="slide__illustration"
            role="img"
            aria-label={this.#componentLocale.illustrationAriaLabel}
          >
            <img
              // base image (acts like a background)
              src={COPYRIGHTS_ILLUSTRATION}
              class="slide__illustration"
              alt={this.#componentLocale.illustrationFigureAriaLabel}
            />
          </div>

          <div class="slide__sign-in">
            <div class="slide__sign-in-container">
              <header class="slide__sign-in-header">
                <img
                  src={ICON_NEXT}
                  alt={this.#componentLocale.illustrationAlternativeText}
                />
                <h2 class="slide__sign-in-title">
                  {this.#componentLocale.title}
                </h2>
              </header>
              <div class="slide__sign-in-description">
                <p>
                  <span>{this.#componentLocale.descriptionText}</span>
                </p>
                <span>
                  {this.#componentLocale.byContinuingTextFirstPart}
                  <a class="terms-conditions" onClick={this.termsCallback}>
                    {this.#componentLocale.byContinuingCallBackText}
                  </a>
                </span>
              </div>
              <div>
                <button
                  class="button-primary sign-in-btn"
                  onClick={this.signInCallback}
                >
                  {this.#componentLocale.signInButtonCaption}
                </button>
              </div>
            </div>
          </div>
        </section>
      </Host>
    );
  }
}
